import { Component } from '@angular/core';
import { SideMenuService } from '../../core/services/side-menu/side-menu.service';
import { Menu } from '../../core/models/menu.model';
import { COMPANY_MENU, MENU } from '../../core/data/menu.data';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { EmpresaService } from '../../core/services/empresa/empresa.service';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss'
})
export class AdminLayoutComponent {

  public menu: Array<Menu> = MENU;

  public title: string = '';

  constructor(
    // public authService: AuthService,
    private activatedRoute: ActivatedRoute,
    public empresaService: EmpresaService,
    private router: Router,
    public sideMenuServie: SideMenuService,
  ) {
    // Escuchar cambios de navegación para capturar parámetros de rutas hijas
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map(route => {
        // Navegar hasta la ruta hija más profunda
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      })
    ).subscribe(route => {
      // Aquí obtienes los parámetros de la ruta activa más profunda

      route.params.subscribe(params => {

        let companyMenu = COMPANY_MENU.map(
          (menuItem) => (
            {
              ...menuItem,
              children: menuItem.children
                ? menuItem.children.map(
                  (child) => (
                    {
                      ...child
                    }
                  )
                )
                : undefined
            }
          )
        );

        console.log('Parámetros de la ruta:', params);
        if (params['idEmpresa']) {
          // console.log('ID Empresa:', params['idEmpresa']);

          const idEmpresa = params['idEmpresa'];

          this.title = '';
          this.getEmpresa(idEmpresa);

          companyMenu.forEach((menuItem) => {

            console.log('Menu Item:', menuItem);


            if (menuItem.route) {

              menuItem.route = menuItem.route.replace('{idEmpresa}', idEmpresa);

            } else {

              menuItem.children?.forEach((submenuItem) => {

                if (submenuItem.route) {

                  submenuItem.route = submenuItem.route.replace('{idEmpresa}', idEmpresa);

                }

              });

            }

          });

          this.menu = companyMenu;
        } else {
          this.menu = MENU;
          this.title = 'Inicio';
          this.empresaService.empresaCurrent = null;
        }
      });
    });

    this.getEmpresas();

  }

  /* -------------------------------------------------------------------------- */
  /*                              ANCHOR getEmpresa                             */
  /* -------------------------------------------------------------------------- */
  // region getEmpresa
  async getEmpresa(
    idEmpresa: string
  ) {

    const empresa = await this.empresaService.get(
      idEmpresa
    );

    if (empresa) {
      this.title = empresa.nombreComercial;
    }

  }

  async getEmpresas() {
    await this.empresaService.getAll();
    // console.log(this.empresaService.empresas);
    if (this.empresaService.empresas.length === 1)
      this.router.navigate([`/admin/empresas/${this.empresaService.empresas[0].idEmpresa}`])


  }
}
